import React, { ReactElement } from 'react';


const SidebarPlaceholderText: React.FC = (): ReactElement => {
    return (
        <div className={'bv-sidebar-content-placeholder-text'}>
            <div className={'bv-sidebar-content-placeholder-text--wrapper'}>
                <p>Navigera genom projektet med hjälp av kartan eller menyn uppe till vänster.</p>
                <p>För pekaren över objekten för att få mer information.</p>
            </div>
        </div>
    );
};


export default SidebarPlaceholderText;